import useRemoveCollectionMutation from './useRemoveCollectionMutation';
import useAppContext from '../../../hooks/useAppContext';
import { DELETE_COLLECTION_SUCCESSFULLY_ALERT } from '../../../consts/alerts';
import { AlertType } from '../../../design-system/DSAlert';

const useDeleteCollection = (
  deletedCollectionId: string,
  onSuccess?: () => void,
) => {
  const { showAlert } = useAppContext();

  const { mutate: deleteCollectionMutation, isPending: isDeleting } =
    useRemoveCollectionMutation({
      onSuccess: () => {
        showAlert({
          message: DELETE_COLLECTION_SUCCESSFULLY_ALERT,
          alertType: AlertType.SUCCESS,
        });
        onSuccess?.();
      },
    });

  const handleDeleteCollection = () => {
    if (deletedCollectionId) {
      deleteCollectionMutation(deletedCollectionId);
    }
  };

  return {
    isDeleting,
    handleDeleteCollection,
  };
};
export default useDeleteCollection;
